// src/reducers/reporterAgentReducer.js
import {
  TRIGGER_REPORTER_RUN_REQUEST,
  TRIGGER_REPORTER_RUN_SUCCESS,
  TRIGGER_REPORTER_RUN_FAILURE,
  RESET_REPORTER_STATE,
} from "../actions/reporterAgentActions";

const initialState = {
  submitStatus: "idle", // idle | submitting | success | error
  lastTicketId: null,
  error: null,
};

const reporterAgentReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRIGGER_REPORTER_RUN_REQUEST:
      return { ...state, submitStatus: "submitting", error: null };

    case TRIGGER_REPORTER_RUN_SUCCESS:
      return {
        ...state,
        submitStatus: "success",
        lastTicketId: action.payload?.ticketId || state.lastTicketId,
        error: null,
      };

    case TRIGGER_REPORTER_RUN_FAILURE:
      return { ...state, submitStatus: "error", error: action.error };

    case RESET_REPORTER_STATE:
      return initialState;

    default:
      return state;
  }
};

export default reporterAgentReducer;
